import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { logError } from "../../../../helpers";

export const useOfficeSettings = ({
  id
}: {
  id: string | null | undefined;
}) => {
  const { apiClient } = useTacticHooks();

  return useQuery({
    queryKey: ["office-settings", id],
    queryFn: async () => {
      if (!id) {
        return null;
      }
      try {
        const data = await apiClient.orgOrOfficeSettings.getOfficeSettings(id);
        if (data.ok && data.result) {
          return data.result;
        }
        throw data;
      } catch (error) {
        logError("Error fetching office settings", error);
        throw error;
      }
    },
    enabled: !!id,
    refetchOnWindowFocus: false
  });
};
